import { Component, ViewChild } from '@angular/core';
import emailjs, { EmailJSResponseStatus } from '@emailjs/browser';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    TranslatePipe,
    RouterLink],
  providers: [provideNativeDateAdapter(), DatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',

})
export class HomeComponent {
  @ViewChild('f') myNgForm: any;
  readonly minDate = new Date() //Set current date
  mailForm: FormGroup;


  constructor(private translate: TranslateService, private fb: FormBuilder, private datePipe: DatePipe, private snackBar: MatSnackBar) {

    this.mailForm = this.fb.group({
      from_customerName: ['', Validators.required],
      from_email: ['', [Validators.required, Validators.email]],
      from_phone: ['', [Validators.required, Validators.pattern(/^[0-9\/\-\+]*$/)]],
      event_type: ['', Validators.required],
      date: ['', Validators.required],
      event_location: ['', Validators.required],
      message: ['', [Validators.required, Validators.maxLength(1000)]],
      from_name: 'Hüpfburgverleih Velbert',
      reply_to: '',
      accept_terms: [false, Validators.requiredTrue],
      accept_privacy: [false, Validators.requiredTrue]
    });

    // Set up the synchronization from `from_email` to `reply_to`
    this.mailForm.get('from_email')?.valueChanges.subscribe(value => {
      this.mailForm.patchValue({ reply_to: value });
    });

  }

  async sendMail() {
    if (this.mailForm.invalid) {
      console.log('Form is invalid');
      return;
    }

    try {
      // Clone the form values to modify
      const publicKey = environment.emailJsPublicKey;
      const formData = { ...this.mailForm.value };

      // Transform pickup_order and accept_terms to "Ja" or "Nein"
      formData.pickup_order = formData.pickup_order ? 'Ja' : 'Nein';
      formData.accept_terms = formData.accept_terms ? 'Ja' : 'Nein';
      formData.accept_privacy = formData.accept_privacy ? 'Ja' : 'Nein';

      // Ensure `date` is in the correct format
      if (formData.date) {
        const dateValue = new Date(formData.date);
        formData.date = this.datePipe.transform(dateValue, 'dd.MM.yyyy');
      }
      const result = await emailjs.send(
        'service_strato',
        'template_ko5z36h',
        formData,
        {
          publicKey: publicKey,
        },
      );
      console.log('E-Mail sent successfully!', result);
      this.myNgForm.resetForm();
    } catch (err) {
      if (err instanceof EmailJSResponseStatus) {
        console.log('EMAILJS FAILED...', err);
        this.snackBar.open(this.translate.instant('email.errorMessage'), 'OK');
        return;
      }

      console.log('There was an error while trying to sent an e-mail', err);
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['green-snackbar'],
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });
  }

  restrictPhoneInput(event: KeyboardEvent) {
    const allowedChars = /^[0-9\/\-\+]*$/;
    const inputValue = event.key;

    const input = event.target as HTMLInputElement;
    const currentValue = input.value;

    if (!allowedChars.test(inputValue) && event.key !== "Backspace") {
      event.preventDefault();
    }
    // Restrict length to max 20 characters
    if (currentValue.length >= 20 && event.key !== "Backspace" && event.key !== "Tab") {
      event.preventDefault();
    }
  }

  onMessageInput(event: Event) {
    const input = event.target as HTMLTextAreaElement; // Type assertion to HTMLTextAreaElement
    const value = input.value;

    // Limit the message input to 1000 characters
    if (value.length > 1000) {
      input.value = value.slice(0, 1000); // Slice the value if it exceeds 1000 characters
      this.mailForm.get('message')?.setValue(input.value); // Update the form control
    } else {
      this.mailForm.get('message')?.setValue(value); // Update the form control for valid input
    }
  }

  sendSuccessMessage() {
    this.openSnackBar(this.translate.instant('email.success'), 'OK');
  }
}
